<template>
    <fieldset>
        <legend>Новый пользователь</legend>
        <table class="grid">
            <tr>
                <td width="25%">
                    <label>ФИО</label>
                    <vee-input v-model="user.fio"  :rules="{required: user.login !== ''}"/>
                </td>
                <td width="25%">
                    <label>Email</label>
                    <vee-input name="Email" v-model="user.email" :rules="{required: user.login !== '',email: true}"/>
                </td>
                <td width="25%">
                    <label>
                        Логин
                        <span class="label bg-red"
                            v-show="user.login !='' && !loginAvailable">Логин занят!</span>
                        <span class="label bg-green" v-show="user.login !== '' && loginAvailable">ОК</span>
                    </label>
                    <vee-input
                        @input="checkLogin"
                        :rules="{required: user.email !== '', loginNotAvailable: !loginAvailable}"
                        :class="{incorrectUrl: user.login !== '' && !loginAvailable}"
                        v-model="user.login"
                        autocomplete="off"
                    />
                </td>
                <td width="25%">
                    <label>Пароль</label>
                    <vee-input v-model="password" name="Пароль" :rules="user.login !== '' ? 'required|min:6' : ''"/>
                </td>
                <td width="100">
                    <label>&nbsp;</label>
                    <button @click.prevent.stop="generatePass" class="small blue">Придумать</button>
                </td>
            </tr>
            <tr>
                <td>&nbsp</td>
                <td colspan="4">
                    <div id="checkMessage"></div>
                </td>
            </tr>
        </table>
    </fieldset>
</template>

<script>
import bcrypt from "bcryptjs";

export default {
    data () {
        return {
            user: {
                fio: '',
                login: '',
                passwordHash: '',
                email: '',
            },
            loginAvailable: true,
            password: '',
        }
    },
    methods: {
        generatePass () {
            this.password = this.$helper.pwgen();
        },
        checkLogin () {
            let data = {
                  login: this.user.login
            };
            this.axios.post('/checkLogin', data).then(response => {
                this.loginAvailable = response.data.loginAvailable;
            });
        },
        calculateHash: _.debounce(function(n) {
            this.user.passwordHash = (n ==='') ? '' : bcrypt.hashSync(n)
        }, 70),
    },
    watch: {
        password (n) {
            this.calculateHash(n);
        },
        user: {
            handler() {
                if (this.user.fio === '' && this.user.login === '' && this.user.email === '' && this.user.passwordHash === ''){
                    this.$emit('fetchUser',null);
                }else{
                    this.$emit('fetchUser',this.user);
                }

            },
            deep: true
        }
    },
}
</script>

<style>


</style>
